import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const NotFoundPage = () => {
	useTitle("Nicht gefunden");

	const icons = [
		{
			name: "error-type-standard",
			size: 64,
			color: "var(--color-error)"
		}
	];

	return (
		<Container
			title="Seite nicht gefunden"
			description={
				<>Leider konnten wir die Seite nicht finden.</>
			}
			buttons={undefined}
			icon={icons[0]}
		></Container>
	);
};

export default NotFoundPage;
